// ======================================================================
// File: RuleManagementPage.jsx
// Module: PPE → FMS → Automation
// Purpose: Automation Rule Management
// ======================================================================

import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import ruleService from "../services/ruleService";
import RuleList from "../components/RuleList";
import RuleDrawer from "../components/RuleDrawer";

export default function RuleManagementPage() {

  const navigate = useNavigate();

  const [rules, setRules] = useState([]);
  const [loading, setLoading] = useState(false);
  const [drawerOpen, setDrawerOpen] = useState(false);

  // -----------------------------------------------------------
  // LOAD RULE LIST
  // -----------------------------------------------------------
  const loadRules = async () => {
    try {
      setLoading(true);

      const res = await ruleService.getRules();

      // backend returns _success(data)
      setRules(res.data || []);

    } catch (err) {
      console.error(err);
      alert("Failed to load automation rules");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadRules();
  }, []);

  // -----------------------------------------------------------
  // UI
  // -----------------------------------------------------------
  return (
    <div>

      {/* =====================================================
          HEADER (Matches FollowupPage Style)
      ====================================================== */}
      <div
        style={{
          background:
            "linear-gradient(90deg, #7c3aed 0%, #9333ea 50%, #a855f7 100%)",
          borderRadius: 12,
          padding: "18px 22px",
          color: "#fff",
          marginBottom: 20,
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          boxShadow: "0 8px 20px rgba(0,0,0,0.15)"
        }}
      >
        <div>
          <h4 style={{ margin: 0, fontWeight: 600 }}>
            🤖 Automation Rules
          </h4>
          <div style={{ fontSize: 13, opacity: 0.9 }}>
            Configure automatic followups and workflow actions
          </div>
        </div>

        <button
          className="btn btn-light"
          style={{
            padding: "8px 18px",
            fontWeight: 500,
            borderRadius: 8
          }}
          onClick={() => setDrawerOpen(true)}
        >
          + New Rule
        </button>
      </div>

      {/* =====================================================
          RULE LIST COMPONENT
      ====================================================== */}
      <RuleList rules={rules} loading={loading} />

      {/* =====================================================
          RULE DRAWER
      ====================================================== */}
      <RuleDrawer
        open={drawerOpen}
        onClose={() => setDrawerOpen(false)}
        onSaved={loadRules}
      />

    </div>
  );
}
